export const IMAGE_SERVER_BASE_URL = "https://admin.monsinidress.com";

function getImageValue(value) {
	if (!value) return "";

	if (typeof value === "string") {
		return value.trim();
	}

	if (typeof value === "object") {
		return String(
			value.url ||
			value.src ||
			value.path ||
			value.imageUrl ||
			value.imageURL ||
			value.filename ||
			""
		).trim();
	}

	return String(value).trim();
}

export function resolveImageUrl(value) {
	const imageValue = getImageValue(value);

	if (!imageValue) return "";

	// Keep complete remote URLs, data URLs and blob URLs exactly as returned.
	if (/^(https?:\/\/|data:|blob:)/i.test(imageValue)) {
		return imageValue;
	}

	if (imageValue.startsWith("//")) {
		return `https:${imageValue}`;
	}

	// Keep bundled/local build assets on the current site.
	if (
		imageValue.startsWith("/static/") ||
		imageValue.startsWith("/assets/")
	) {
		return imageValue;
	}

	// API image paths such as uploads/... or /uploads/... use the admin server.
	return `${IMAGE_SERVER_BASE_URL}/${imageValue.replace(/^\/+/, "")}`;
}

export function getProductImageUrl(product, index = 0) {
	if (!product) return "";

	const images = Array.isArray(product.images) ? product.images : [];

	const candidates =
		index === 0
			? [
					product.url,
					product.imageUrl,
					product.imageURL,
					product.image,
					product.src,
					product.thumbnail,
					images[0],
			  ]
			: [images[index]];

	for (const candidate of candidates) {
		const resolved = resolveImageUrl(candidate);
		if (resolved) return resolved;
	}

	return "";
}

export function getProductImageUrls(product) {
	if (!product) return [];

	const images = Array.isArray(product.images) ? product.images : [];
	const candidates = [
		product.url,
		product.imageUrl,
		product.imageURL,
		product.image,
		product.src,
		product.thumbnail,
		...images,
	];

	const seen = new Set();
	const resolvedImages = [];

	for (const candidate of candidates) {
		const resolved = resolveImageUrl(candidate);
		if (!resolved || seen.has(resolved)) continue;
		seen.add(resolved);
		resolvedImages.push(resolved);
	}

	return resolvedImages;
}
